import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDevices: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"devices, macbook, iphone, phone, connected"} maskId="square-filled-radius-0-stroke-1-IconDevices"><path d="M20 19H17V20H20V19Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M23 8H21V3H3V17H1.5V21H14V22H23V8ZM2.5 18V20H14V18H2.5ZM15 21H22V9H15V21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDevices;
